<template>
  <div class="navleft-db floatL">
    <ul>
      <li v-if="curNav.pid != 0 || curNav.id==item.id" :class="curNav.id==item.id?'cur':''"v-for="item in navList">
          <a :href="item.web_url!=''?item.web_url:'javascript:void(0)'">{{item.name}}</a>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "tNavleft",
    data() {
      return {
          navList: [],
          curNav: null
      }
    },
    mounted() {
      this.initData();
    },
    methods: {
        initData: async function () {
            let url = window.location.pathname + window.location.search;
            let res = await this.$getJSON('nav/leftNav',{url:url});
            if (res.code == 1) {
                this.navList = res.data.navList;
                this.curNav = res.data.curNav;
            }
        },

    }
  }
</script>

<style lang="scss">
  .navleft-db{
    width: 210px;
    padding: 30px 15px;
    box-sizing: border-box;
    border: 1px solid #dee2e6;
    ul{
      li{
        width: 180px;
        height: 54px;
        line-height: 54px;
        background: #f8f9fa;
        font-size: 18px;
        text-align: center;
        margin-bottom: 10px;
        &:last-child{
          margin-bottom: 0;
        }
        &.cur{
          background: #ff2564;
          color: #fff;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/layout/navleft.vue